import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a153be7e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a153be7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a153be7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a153be7e')) {
      api.createRecord('a153be7e', component.options)
    } else {
      api.reload('a153be7e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a153be7e&scoped=true", function () {
      api.rerender('a153be7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/set-historytimedetail/index.vue"
export default component.exports